import { FARM_CUSTOMER_LIST, FARM_CUSTOMER_LIST_REQUESTING, USER_CUSTOMER_LIST, USER_CUSTOMER_LIST_REQUESTING } from "../constants/action-types";
import { apiResponse, defaultAgent } from "../helpers/web-agent";
import { tokenExpired } from "./auth";
import { toastError, toastSuccess } from "./toast";

export const farmCustomerList = payload => ({ type: FARM_CUSTOMER_LIST, payload });

export const farmCustomerListRequest = () => ({ type: FARM_CUSTOMER_LIST_REQUESTING });

export const userCustomerList = payload => ({ type: USER_CUSTOMER_LIST, payload });

export const userCustomerListRequest = () => ({ type: USER_CUSTOMER_LIST_REQUESTING });

export const getFarmCustomerList = params => dispatch => {
    dispatch(farmCustomerListRequest());
    defaultAgent.get(`/api/customer/list`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(farmCustomerList(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getUserCustomerList = params => dispatch => {
    dispatch(userCustomerListRequest());
    defaultAgent.get(`/api/customer/user/list`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(userCustomerList(agentResult.data));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const saveCustomer = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/customer/save', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === 10000) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}

export const saveFarmCustomer = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/customer/farm/save', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === 10002 || 10006) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}

export const saveCustomerUser = (data, cb) => {
    return dispatch => {
        defaultAgent.post('/api/customer/user/save', data)
            .then(res => {
                const agentResult = apiResponse(res, {});
                if (agentResult.isUnauthorized) {
                    dispatch(toastError(agentResult.message));
                    dispatch(tokenExpired());
                } else if (agentResult.code === 10004) {
                    if (cb) cb(true);
                    dispatch(toastSuccess(agentResult.message));
                } else if (agentResult.message) {
                    if (cb) cb(false);
                    dispatch(toastError(agentResult.message));
                }
            }).catch(ex => {
                if (cb) cb(false);
                dispatch(toastError(ex.message));
            });
    }
}